import React from 'react'
import Header from '../Components/Header'
import PageLayout from '../Layouts/PageLayout';
import {ArrowDownIcon} from '@heroicons/react/20/solid';
import AdmissionForm from './AdmissionComponents/AdmissionForm';
import BatchSelector from './AdmissionComponents/BatchSelector';
import { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';



export default function Admission() {

    const t = useLanguage().content.ui.admission;

    const [selectedBatch, setSelectedBatch] = useState("");
    const [selectedCourse, setSelectedCourse] = useState("");
    const [step, setStep] = useState(1);

    const onBatchSelect = (batch, course) => {
      setSelectedBatch(batch);
      setSelectedCourse(course);

    };
  
    return (
        <PageLayout header={
            <Header title={t.title}>
                <p className="text-primary mt-2">{t.sistersOnly}</p>
            </Header>
        }
        firstColumn={
            <div className="flex flex-col items-center lg:gap-8 mt-8">
               <div className={`p-4 rounded-lg ${step >= 1 ? 'bg-primary text-white' : 'bg-bgMuted text-textDark'} transition-colors`}>
                 <h1 className="font-bold text-lg">{t.steps[0]}</h1>
               </div>
               <ArrowDownIcon className={`h-16 ${step >= 1 ? "fill-primary" : "fill-bgMuted"}`}/>
               <div className={`p-4 rounded-lg ${step >= 2 ? 'bg-primary text-white' : 'bg-bgMuted text-textDark'} transition-colors`}>
                 <h1 className="font-bold text-lg">{t.steps[1]}</h1>
               </div>
               <ArrowDownIcon className={`h-16 ${step >= 2 ? "fill-primary" : "fill-bgMuted"}`}/>
               <div className={`p-4 rounded-lg ${step >= 3 ? 'bg-primary text-white' : 'bg-bgMuted text-textDark'} transition-colors`}>
                 <h1 className="font-bold text-lg">{t.steps[2]}</h1>
               </div>
               
               <div className="mt-8 p-4 bg-secondary/20 rounded-lg text-center">
                 <p className="text-sm text-textDark">{t.contactDirectly}</p>
                 <div className="flex gap-4 mt-2 justify-center">
                   <a href="https://www.facebook.com/profile.php?id=100063740185932" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-primaryLight underline text-sm">Facebook</a>
                   <a href="https://t.me/+x0YcI4hRFw41Mzc1" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-primaryLight underline text-sm">Telegram</a>
                 </div>
               </div>
            </div>
        }
        >
           <div className="p-6 col-span-2 bg-bgMuted/30 rounded-xl w-full border border-secondary/20 shadow-sm">
            { 
                (step === 1) && 
                    <BatchSelector selectedCourse={selectedCourse} selectedBatch={selectedBatch} onBatchSelect={onBatchSelect} setToNextStep={setStep}/>
            }       
            {   
                (step === 2) && 
                    <AdmissionForm batch={selectedBatch} course={selectedCourse} setToNextStep={setStep}/>
            }
            {   
                (step === 3) && 
                    <div className="mt-10 flex flex-col justify-center items-center gap-8">
                        <div className="text-center">
                          <h2 className="text-3xl font-serif font-bold text-primary">{t.welcomeLine1}</h2>
                          <h2 className="text-2xl font-serif font-bold text-primary mt-2">{t.welcomeLine2}</h2>
                        </div>
                        <div className="bg-white p-6 rounded-xl shadow-md border border-secondary/20">
                          <h2 className="text-lg font-medium text-textDark mb-4">{t.batchLink}</h2>
                          <article className="p-4 border-2 border-primary bg-primary/5 rounded-lg font-mono text-sm break-all">
                              {selectedBatch.telegramLink}
                          </article>
                        </div>
                        <a className="bg-primary hover:bg-primaryLight text-white px-8 py-3 rounded-lg font-semibold transition-colors shadow-md" href={selectedBatch.telegramLink} target="_blank" rel="noopener noreferrer">
                          {t.joinTelegram}
                        </a>
                    </div>
            }
            </div>        
            </PageLayout>
    );
  };
